import React from 'react';
import './ComingSoon.scss';

function ComingSoon() {
  return (
    <div id="coming-soon-container">
      <header>
        <h4>Future home of...</h4>
        <h1>Full Impact Scheduling</h1>
        <p className="mt-4">
          We are working on a brand new lesson scheduling application.
          We are hopeful this will be a better system than we had prior.
          In the meantime, you can look at our current schedule availability on <a href="https://teamreach.com" target="_blank" rel="noreferrer">Team Reach</a> (Enter Code: <strong>Hribar28</strong>)
        </p>
      </header>
    </div>
  );
}

export default ComingSoon;